/** Safe in-app path for post-login redirect (no open redirects). */
export function sanitizeReturnTo(raw) {
  const s = String(raw || "").trim();
  if (!s.startsWith("/") || s.startsWith("//")) return null;
  if (s.includes("://")) return null;
  if (s.length > 300) return null;
  return s;
}

function parentCookieDomain() {
  const host = window.location.hostname;
  if (!host || host === "localhost" || host.endsWith(".localhost")) return null;
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return null;
  const parts = host.split(".");
  if (parts.length < 2) return null;
  return `.${parts.slice(-2).join(".")}`;
}

/**
 * Mirror a slim session onto a parent-domain cookie so www / apex share login.
 * Guild lists stay in localStorage / refresh API (cookie size limits).
 */
export function writeSessionCookie({ id, username, avatar, token }) {
  if (!id || !token) return;
  try {
    const payload = encodeURIComponent(
      JSON.stringify({ id, username, avatar, token }),
    );
    const domain = parentCookieDomain();
    const parts = [
      `kami_auth=${payload}`,
      "Path=/",
      "Max-Age=604800",
      "SameSite=Lax",
    ];
    if (domain) parts.push(`Domain=${domain}`);
    if (window.location.protocol === "https:") parts.push("Secure");
    document.cookie = parts.join("; ");
  } catch {
    /* ignore quota / privacy mode */
  }
}

export function clearSessionCookie() {
  try {
    const domain = parentCookieDomain();
    const expire = "kami_auth=; Path=/; Max-Age=0; SameSite=Lax";
    document.cookie = expire;
    if (domain) {
      document.cookie = `${expire}; Domain=${domain}`;
    }
  } catch {
    /* ignore */
  }
}

export function readSessionCookie() {
  try {
    const match = document.cookie
      .split("; ")
      .find((row) => row.startsWith("kami_auth="));
    if (!match) return null;
    const raw = decodeURIComponent(match.slice("kami_auth=".length));
    const parsed = JSON.parse(raw);
    if (!parsed?.id || !parsed?.token) return null;
    return parsed;
  } catch {
    return null;
  }
}

const API_BASE = process.env.REACT_APP_API_BASE;

/** Discord OAuth login, optionally returning to the current page afterward. */
export function startLogin(returnTo) {
  const path =
    sanitizeReturnTo(returnTo) ||
    sanitizeReturnTo(
      `${window.location.pathname}${window.location.search || ""}`,
    ) ||
    "/servers";
  try {
    sessionStorage.setItem("kami_return_to", path);
  } catch {
    /* ignore */
  }
  window.location.href = `${API_BASE}/auth/login?returnTo=${encodeURIComponent(path)}`;
}
